import { render } from "./Offers.vue?vue&type=template&id=66438824"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=66438824&lang=css"
script.render = render

export default script